export const WebUiPaymentBankAccountModalEnI18n = {
    title: 'Bank Details',
    actions: {
        add: 'Add Bank Account',
    },
};
